import { SKILLS_OPTIONS } from '../constants/skillsOptions';

export const getStatusStyle = (status) => {
  const styles = {
    'ACTIVE': 'bg-green-100 text-green-800 border-green-200',
    'PENDING': 'bg-yellow-100 text-yellow-800 border-yellow-200',
    'INACTIVE': 'bg-gray-100 text-gray-800 border-gray-200',
    'SUSPENDED': 'bg-red-100 text-red-800 border-red-200'
  };
  return styles[status] || 'bg-gray-100 text-gray-800';
};

export const getRoleStyle = (role) => {
  const styles = {
    'customer': 'bg-orange-100 text-orange-700 border-orange-200',
    'vendor': 'bg-orange-200 text-orange-800 border-orange-300',
    'admin': 'bg-orange-300 text-orange-900 border-orange-400'
  };
  return styles[role] || 'bg-gray-100 text-gray-800';
};

export const getSkillLabel = (skillValue) => {
  const skill = SKILLS_OPTIONS.find(s => s.value === skillValue);
  return skill ? skill.label : skillValue;
};

export const mapLegacySkillToValue = (skillText) => {
  const skillLower = skillText.toLowerCase().trim();
  const mapping = {
    'plumbing': 'plumbing',
    'electrical': 'electrical', 
    'carpentry': 'carpentry',
    'painting': 'painting',
    'hvac': 'hvac',
    'heating': 'hvac',
    'cooling': 'hvac',
    'appliance repair': 'appliance_repair',
    'appliances': 'appliance_repair',
    'flooring': 'flooring',
    'roofing': 'roofing',
    'gardening': 'gardening',
    'landscaping': 'gardening',
    'cleaning': 'cleaning',
    'pest control': 'pest_control',
    'handyman': 'handyman',
    'general': 'handyman',
    'locksmith': 'locksmith',
    'masonry': 'masonry',
    'brickwork': 'masonry',
    'drywall': 'drywall',
    'insulation': 'drywall',
    'windows': 'windows_doors',
    'doors': 'windows_doors'
  };
  
  return mapping[skillLower] || skillLower;
};

export const processSkillsArray = (skills) => {
  if (!Array.isArray(skills)) return [];
  
  return skills.map(skill => {
    // If skill is already a valid value, keep it
    if (SKILLS_OPTIONS.some(opt => opt.value === skill)) {
      return skill;
    }
    // Otherwise, try to map it from legacy format
    return mapLegacySkillToValue(skill);
  }).filter(skill => SKILLS_OPTIONS.some(opt => opt.value === skill));
};
